import React from "react";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import {
  ButtonBlue,
  ButtonGray,
  ButtonRed
} from "components/Global/Modal/Layout/Buttons";

import { connect } from "react-redux";
import { hideModal } from "redux/modules/modal/actions";

const decorate = connect(null, {
  hideModal
});

const DeleteConfirmationModal = ({
  method = "confirm",
  hideModal,
  message,
  onConfirm,
  confirmLabel,
  zIndex = undefined,
  cancelLabel = undefined,
  onCancel = undefined
}) => {
  const ConfirmButton = method === "delete" ? ButtonRed : ButtonBlue;

  return (
    <StyleWrapper
      {...(zIndex !== undefined ? { zIndex } : {})}
      width="440px"
      hideModal={hideModal}
      hideHeader
      bodyStyles={{
        padding: "0px"
      }}
    >
      <div
        style={{
          color: "#000",
          fontSize: "18px",
          padding: "24px 24px 16px 24px"
        }}
      >
        {message}
      </div>
      <div
        style={{
          width: "100%",
          border: "1px solid #E7E6EA",
          height: "1px"
        }}
      ></div>
      <div
        style={{
          padding: "16px 24px 16px 24px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <ConfirmButton
          onClick={() => {
            onConfirm();
            hideModal();
          }}
          title={confirmLabel}
          style={{
            borderRadius: "20px",
            flex: 1,
            width: "45%",
            marginRight: "24px"
          }}
        />
        <ButtonGray
          onClick={() => {
            hideModal();
            if (onCancel) onCancel();
          }}
          title={cancelLabel || "Cancel"}
          style={{
            borderRadius: "20px",
            flex: 1,
            width: "45%"
          }}
        />
      </div>
    </StyleWrapper>
  );
};

export default decorate(DeleteConfirmationModal);
